<div class="w-full text-center mt-4 mb-8">
    <p class="text-xs sm:text-sm md:text-lg">
        Contact Us:
        <a [href]="'mailto:' + email" tabIndex="0">{{ email }}</a>
        | <a [href]="'tel:' + phone" tabIndex="0">{{ phone }}</a>
        | Fax: {{ fax }}
    </p>
</div>
